// extracted by mini-css-extract-plugin
export default {"wrapper":"_3G7nYr1rJN","focus":"_2XjUkFRFD5","read-only":"d68CddLptd","readOnly":"d68CddLptd"};
    if(module.hot) {
      // 1623933213480
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  